import { render } from "./lookPDF.vue?vue&type=template&id=4ee86900&scoped=true"
import script from "./lookPDF.vue?vue&type=script&lang=js"
export * from "./lookPDF.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee86900"]])

export default __exports__